
import { Component, Prop, Vue } from "vue-property-decorator";
import { SMCases, SMUser } from "@/store";
import { API_TCaseCategory, API_TCaseProfile } from "@/models/case_profiles";
import { NOTIFICATION_PROPS, NOTIFICATION_PROPS_LOCK } from "@/constants/notification";

@Component({
  components: {
    NotificationTemplate: () =>
      import("@/components/NotificationTemplate/NotificationTemplate.vue"),
    CaseNotification: () =>
      import("@/modules/Services/Components/Notification/CaseNotification.vue"),
    ProfileTemplate: () => import("@/components/ProfileTemplate/ProfileTemplate.vue"),
  },
})
export default class VCandidateOrEmployerTemplateProfile extends Vue {
  @Prop({ type: [Object, String], default: () => ({}) }) readonly src?: API_TCaseProfile;
  @Prop({ type: Number, default: 0 }) readonly serviceId?: number;
  @Prop({ type: Boolean, default: false }) readonly isEditable?: boolean;
  @Prop({ type: Boolean, default: false }) readonly otherUserHasTasks?: boolean;
  @Prop({ type: String, default: "" }) readonly editNotificationLabel?: string;

  get categories(): API_TCaseCategory[] {
    return this.src?.categories ?? [];
  }

  serviceEditCheck(payload: { caseId: number; stepId: number; type: string }): void {
    this.$emit("edit", payload);
  }

  get notificationProps() {
    return SMUser.isEmployee ? NOTIFICATION_PROPS : NOTIFICATION_PROPS_LOCK;
  }

  get showNotification() {
    return !SMCases.isDependantCase;
  }

  get showEditingNotification() {
    return !this.isEditable;
  }
}
